export function getHoursMinutes(ms: number = +new Date()): string {
  const dat = new Date(ms);
  return`${addTimeZero(dat.getHours())}:${addTimeZero(dat.getMinutes())}`;
}

function addTimeZero (item: string | number) {
  return `0${item}`.slice(-2);
}